import { enUS, enGB, enCA, ptBR, frCA, pt, it, de, fr, es } from 'date-fns/locale';
import esUS from './esUS';
export const locales = {
  'en-US': enUS,
  'en-GB': enGB,
  'en-CA': enCA,
  'pt-BR': ptBR,
  'es-US': esUS,
  'fr-CA': frCA,
  pt: pt,
  it: it,
  de: de,
  es: es,
  fr: fr
};
// In RC some locales contain country modifcations. example es-MX. But these may not exist in date-fns so return the language-only value.
const supportedLocale = locale => {
  if (locales[locale]) return locale;
  if (locales[locale.substr(0, 2)]) return locale.substr(0, 2);else return 'en-US';
};
export const validateLocale = aliasLocale => {
  if (!aliasLocale) return 'en-US';
  if (aliasLocale === 'en') return 'en-US';
  const matchedLocale = aliasLocale.match(/([a-z]{2})(?:-?([a-zA-Z]{2})?)/);
  if (matchedLocale && matchedLocale.length && matchedLocale[2] === undefined) return supportedLocale(matchedLocale[1]);else if (matchedLocale && matchedLocale.length && matchedLocale[2]) return supportedLocale(matchedLocale[1].concat('-', matchedLocale[2].toUpperCase()));else return 'en-US';
};
export const getLocalized = locale => {
  const validatedLocale = validateLocale(locale);
  return locales[validatedLocale] && locales[validatedLocale].localize;
};